import { RemarkComponent } from "./remark/remark.component";

export const components: any[] = [
    RemarkComponent,
];

export * from './remark/remark.component';
